export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const isValidEmail = (email?: string): boolean => (email ? emailRegex.test(email) : false);

export const phoneRegex = /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/;
export const phoneMask = '+7 (___) ___-__-__';
export const isValidPhone = (phone?: string): boolean => {
  const phoneDigits = phone?.replace(/\D/g, '');
  return phoneDigits ? phoneDigits.length === 11 : false;
};
